import {combineReducers} from "redux";
import invitationPage from './invitationPage';
import list from './list';
import sendInvitation from './sendInvitation';
import updateExpiresAt from './updateExpiresAt';
import invitationEmailDefaultContent from './invitationEmailDefaultContent';

export default combineReducers({list, invitationPage, sendInvitation, updateExpiresAt, invitationEmailDefaultContent});
